import http from "../httpService";
import { apiUrl, api } from "../../config.json";

export const register = (payload) => {
  return http.post(api + "/user/register", payload);
};

export const googlelog = (payload) => {
  return http.post(api + "/user/googleLogin", payload);
};
export const verifyEmail = (payload) => {
  return http.get(api + "/user/emailVerify/" + payload);
};
export const passwordChange = (payload) => {
  return http.post(api + "/user/verifyUser", payload);
};
export const newPassword = (payload) => {
  return http.post(api + "/change-password", payload);
};

// export const findMail = (payload) => {
//   return http.post(api + '/findGmail', payload)
// };

export const login = (payload) => {
  return http.post(api + "/user/login", payload);
};

export const setToken = (token) => {
  localStorage.setItem("token", token.toString());
  sessionStorage.setItem("token", token.toString());
};

export const getAuthToken = () => {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
};

export const clearAuthSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("loginType");
  sessionStorage.clear();
};

export const logoutToLogin = () => {
  clearAuthSession();
  window.location.replace("/login");
};

const parseJwt = (token) => {
  if (token) {
    try {
      const basedUrls = token.split(".");
      const base64Url = basedUrls[1];
      if (!base64Url) return {};
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
      const binary = atob(padded);
      const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
      return JSON.parse(new TextDecoder("utf-8").decode(bytes));
    } catch (error) {
      return {};
    }
  }
  return {};
};

export const getPayLoad = () => {
  return parseJwt(getAuthToken());
};

export const userInfo = () => {
  return getPayLoad();
};

export const userEmail = () => {
  return getPayLoad().email || "";
};

export const userRole = () => {
  return getPayLoad().role || "";
};

export const userID = () => {
  return getPayLoad().userID || "";
  // return 17;
};
export const ID = () => {
  return getPayLoad()._id || "";
  // return 17;
};

export const userCurriculumCode = () => {
  return getPayLoad().curriculumCode || "";
  // return "TEST";
};
export const assignCurrculum = () => {
  return getPayLoad().assignCurrculum || [];
  // return "TEST";
};
export const userCurriculum = () => {
  return getPayLoad().curriculum || "";
  // return "TEST";
};

export const userCurriculumsList = () => {
  return getPayLoad().userCurriculum || [];
};

export const teacherSubject = () => {
  return getPayLoad().subject || "";
};
export const orderPayment = (payload) => {
  return http.post(api + "/user/orderPayment", payload);
};
export const verfyPayment = (payload) => {
  return http.post(api + "/user/verifyOrder", payload);
};

export const cashPayment = (payload) => {
  return http.post(api + "/user/cashPayment", payload);
};

// Note: cashPaymentVerify is available in Admin/commonService.js for admin use
// This duplicate in AuthService can be removed if not needed for student-facing features

// Get payment status by payment document ID (optional - for checking payment status)
export const getPaymentStatus = (paymentId) => {
  return http.get(api + "/user/getOrder/" + paymentId);
};

export const verifyUser = (payload) => {
  return http.post(api + "/user/verifyUser", payload);
};
export const forgetPassword = (payload) => {
  return http.post(api + "/user/forgetPassword", payload);
};

// export const getOrderPayment = (payload) => {
//   return http.post(api + "/post/orderPayment", payload);
// };

export const addUploadFileData = (userID, payload) => {
  return http.post(api + `/user/addUploadFileData/${userID}`, payload);
};
